import { render, staticRenderFns } from "./dealRules.vue?vue&type=template&id=098e0a24&scoped=true&"
import script from "./dealRules.vue?vue&type=script&lang=js&"
export * from "./dealRules.vue?vue&type=script&lang=js&"
import style0 from "./dealRules.vue?vue&type=style&index=0&id=098e0a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e0a24",
  null
  
)

export default component.exports